import styled, { useTheme } from "styled-components";

import { ThisGorillaUtils } from "@thisgorilla/primate-ds";
import { Divider, hideScrollBar } from "../../../../commonStyles";
import { FlexColumn } from "../../../Common/Styles";
import { UserDetails } from "./1-UserDetails";
import { FollowersFollowing } from "./2-FollowersFollowing";
import { Studio } from "./3-Studio";
import { Pods } from "./4-Pods";
import AdUnit from "./5-AdUnit";

export const LeftPanel = () => {
  const { Color } = useTheme();
  const color = Color.border["ui-border-subtle"].value;
  return (
    <ScrollContainer>
      <Container className="left-panel">
        <Divider $color={color} />
        <UserDetails />
        <Divider $color={color} />
        <FollowersFollowing />
        <Divider $color={color} />
        <Studio />
        <Pods />
        <Divider $color={color} />
        <AdUnit />
      </Container>
    </ScrollContainer>
  );
};

const ScrollContainer = styled.div`
  max-height: calc(100vh - ${ThisGorillaUtils.convertPxToRem("136")}rem);
  overflow-y: scroll;
  position: sticky;
  z-index: 3;
  top: ${ThisGorillaUtils.convertPxToRem("104")}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  ${hideScrollBar}
`;
const Container = styled(FlexColumn)`
  width: ${ThisGorillaUtils.convertPxToRem("332")}rem;
  gap: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-6"].value}rem
    ${({ theme }) => theme.spacing["spacing-4"].value}rem;
`;
